import * as React from "react";
import * as numeral from "numeral";
import { ChangeEvent, Component, MouseEvent } from "react";

import Field from "components/FormElements/Field";
import ToolTip from "components/ToolTip";

import MoneyInput from "./MoneyInput";

import { currencyStringToFloat } from "./utils";

interface PropsType {
  error?: string;
  feeDisplayEnabled: boolean;
  onChange(e: ChangeEvent<HTMLInputElement>): void;
  onRoundUp(e: MouseEvent): void;
  roundingEnabled: boolean;
  value: string;
}

interface StateType {
  isPaycheckAmountFieldDirty: boolean;
}

export default class PaycheckAmountField extends Component<
  PropsType,
  StateType
> {
  state = { isPaycheckAmountFieldDirty: false };
  onRoundUp = (event: MouseEvent<HTMLButtonElement>): void => {
    const { onRoundUp } = this.props;
    this.setState({ isPaycheckAmountFieldDirty: true });
    onRoundUp(event);
  };

  render(): JSX.Element {
    const {
      props: { error, feeDisplayEnabled, onChange, roundingEnabled, value },
      state: { isPaycheckAmountFieldDirty },
    } = this;

    return (
      <div className="amount-per-paycheck">
        <Field
          className="text"
          id="wage_schedule_amount_deducted_per_paycheck"
          label="Amount from Each Paycheck"
          name="wage_schedule[amount_deducted_per_paycheck]"
          onlyDirtyErrors={!isPaycheckAmountFieldDirty}
          toolTip={
            <ToolTip
              heading="Amount from Each Paycheck"
              content={`This is the plan amount that is calculated
          to come out of each paycheck, based on the monthly
          amount and the payment schedule.`}
            />
          }
          {...{ error, onChange }}
        >
          <MoneyInput {...{ value }} />
        </Field>

        <div className="total-with-fee" hidden={!feeDisplayEnabled}>
          <i className="fas fa-exclamation-triangle" />

          <span>Total with TFS technology fee: </span>

          <span>
            {numeral(currencyStringToFloat(value) + 1.99).format("$0.00")}
          </span>
        </div>

        <div className="form--actions" hidden={!roundingEnabled}>
          <button
            className="button--orange"
            disabled={!!error}
            onClick={this.onRoundUp}
            type="button"
          >
            <i className="fas fa-level-up-alt" />
            <strong>Round Up</strong>
          </button>
        </div>
      </div>
    );
  }
}
